var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"app":"","fixed":""}},[_c('span',[_vm._v("© "+_vm._s(_vm.currentYear)+" Just Works bvba")])])}
var staticRenderFns = []

export { render, staticRenderFns }